import { useEffect, useRef } from "react";
import * as pdfjsLib from "pdfjs-dist";
import "pdfjs-dist/build/pdf.worker.entry";
import styles from "../assets/styles/componenets/teachers.module.css"

function PDFViewer({ url, onRenderComplete }) {
    const canvasRef = useRef(null);

    useEffect(() => {
        let renderTask = null;
        let loadingTask = pdfjsLib.getDocument(url);

        loadingTask.promise.then((pdf) => pdf.getPage(1)).then((page) => {
            const canvas = canvasRef.current;
            const context = canvas.getContext("2d");

            const maxDisplayWidth = Math.min(window.innerWidth * 0.9, 1000); // cap at 1000px for desktop
                const unscaledViewport = page.getViewport({ scale: 1 });
                const scale = maxDisplayWidth / unscaledViewport.width;
                const viewport = page.getViewport({ scale });

                // Scale for crispness
                const dpr = window.devicePixelRatio || 1;
                canvas.width = viewport.width * dpr;
                canvas.height = viewport.height * dpr;
                canvas.style.width = `${viewport.width}px`;
                canvas.style.height = `${viewport.height}px`;

                context.setTransform(dpr, 0, 0, dpr, 0, 0);

                renderTask = page.render({
                    canvasContext: context,
                    viewport,
                });

                return renderTask.promise;
        }).then(() => {
            if (onRenderComplete) onRenderComplete();
        }).catch((err) => {
            if (
                err?.name !== "RenderingCancelledException" &&
                err?.message !== "Loading aborted"
            ) {
                console.error("PDF error:", err);
            }
        });

        return () => {
            if (renderTask) renderTask.cancel();
            if (loadingTask) loadingTask.destroy();
        };
    }, [url, onRenderComplete]);

    return (
        <div
            className={styles.cvContainer}
        >
            <canvas ref={canvasRef} style={{ display: "block" }}/>
        </div>
    );
}

export default PDFViewer;
